import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {},
	finalize() {
		//animation / gsap
		//body
		let $singleImage = $('.single-image')[0]
		if ($singleImage) {
			gsap.fromTo(
				'.single-image',
				{
					x: -65,
					opacity: 0,
				},
				{
					scrollTrigger: '.single-image',
					delay: 0.5,
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
		}
		let $copy = $(
			'.single-content-wrap p:not(.wp-block-group__inner-container p), .single-content-wrap img, .single-content-wrap li, .single-content-wrap h2, .single-content-wrap h3, .single-content-wrap h4'
		)
		if ($copy.length) {
			document
				.querySelectorAll(
					'.single-content-wrap p:not(.wp-block-group__inner-container p), .single-content-wrap img, .single-content-wrap li, .single-content-wrap h2, .single-content-wrap h3, .single-content-wrap h4'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ y: 15, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							y: 0,
							opacity: 1,
						}
					)
				})
		}
		let $quotes = $(
			'.single-content-wrap .wp-block-pullquote, .single-content-wrap .wp-block-quote'
		)
		if ($quotes.length) {
			document
				.querySelectorAll(
					'.single-content-wrap .wp-block-pullquote, .single-content-wrap .wp-block-quote'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ y: 15, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							y: 0,
							opacity: 1,
						}
					)
				})
		}
		let $separators = $('.single-content-wrap .wp-block-separator')
		if ($separators.length) {
			document
				.querySelectorAll('.single-content-wrap .wp-block-separator')
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ y: 15, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							y: 0,
							opacity: 1,
						}
					)
				})
		}
		//coastal text & media block
		let $oddMediaBlock = $(
			'.single-content-wrap .coastal-text-media-block:nth-of-type(odd)'
		)
		if ($oddMediaBlock.length) {
			document
				.querySelectorAll(
					'.single-content-wrap .coastal-text-media-block:nth-of-type(odd)'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: 50, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}
		let $evenMediaBlock = $(
			'.single-content-wrap .coastal-text-media-block:nth-of-type(even)'
		)
		if ($evenMediaBlock.length) {
			document
				.querySelectorAll(
					'.single-content-wrap .coastal-text-media-block:nth-of-type(even)'
				)
				.forEach((item) => {
					gsap.fromTo(
						item,
						{ x: -50, opacity: 0 },
						{
							scrollTrigger: item,
							delay: 0.5,
							duration: 0.5,
							x: 0,
							opacity: 1,
						}
					)
				})
		}
	},
}
